<button  [attr.type]="type" [class]="[color, expand, hasIcon, size + '-button', customClass]" [disabled]="disabled">
  <ng-content></ng-content>
</button>
